export interface WalletRequestOpeningJson {
  is_company_creation: boolean;
  business_appointment_done: boolean;
  user_invited_id: number;
  secondary_account: string;
  promo_code: string;
  comment: string;
  identity_file: File;
  kbis_file: File;
  statuts_file: File;
}

export class WalletRequestOpening {
  constructor(
    public isCompanyCreation: boolean,
    public businessAppointmentDone: boolean,
    public userInvitedId: number,
    public secondaryAccount: string,
    public promoCode: string,
    public comment: string,
    public identityFile: File,
    public kbisFile: File,
    public statutsFile: File
  ) {}

  static fromJson(json: WalletRequestOpeningJson): WalletRequestOpening {
    return new WalletRequestOpening(
      json.is_company_creation,
      json.business_appointment_done,
      json.user_invited_id,
      json.secondary_account,
      json.promo_code,
      json.comment,
      json.identity_file,
      json.kbis_file,
      json.statuts_file
    );
  }

  static toJson(model: WalletRequestOpening): WalletRequestOpeningJson {
    return {
      is_company_creation: model.isCompanyCreation,
      business_appointment_done: model.businessAppointmentDone,
      user_invited_id: model.userInvitedId,
      secondary_account: model.secondaryAccount,
      promo_code: model.promoCode,
      comment: model.comment,
      identity_file: model.identityFile,
      kbis_file: model.kbisFile,
      statuts_file: model.statutsFile
    };
  }
}
